import { Link } from '@remix-run/react';
import { CircleXIcon, HashIcon } from 'lucide-react';
import { Badge } from '~/components/ui/badge';

interface Props {
  query?: string;
  brands: {
    id: string;
    name: string;
  }[];
  tags: {
    id: string;
    tag: string;
  }[];
  selectedTags: string[];
  selectedBrands: string[];
}

export const SearchedFilterBadges = ({
  brands,
  tags,
  selectedBrands,
  selectedTags,
  query
}: Props) => {
  const basePath = '/pedals';

  const deleteQuery = (): string => {
    const queryParams = new URLSearchParams();

    if (selectedTags.length > 0) {
      queryParams.append('tags', selectedTags.join(','));
    }

    if (selectedBrands.length > 0) {
      queryParams.append('brands', selectedBrands.join(','));
    }

    if (selectedTags.length < 1 && selectedBrands.length < 1) {
      return basePath;
    }

    return `${basePath}?${queryParams.toString()}`;
  }

  const deleteTag = (deleteTagId: string): string => {
    const queryParams = new URLSearchParams();

    console.dir(query)
    if (query) {
      queryParams.append('query', query);
    }

    const deletedSelectedTags = selectedTags.filter((tagId) => tagId !== deleteTagId);
    if (deletedSelectedTags.length > 0) {
      queryParams.append('tags', deletedSelectedTags.join(','));
    }

    if (selectedBrands.length > 0) {
      queryParams.append('brands', selectedBrands.join(','));
    }

    if (deletedSelectedTags.length < 1 && selectedBrands.length < 1 && !query) {
      return basePath;
    }

    return `${basePath}?${queryParams.toString()}`;
  }

  const deleteBrand = (deleteBrandId: string): string => {
    const queryParams = new URLSearchParams();

    if (query) {
      queryParams.append('query', query);
    }

    if (selectedTags.length > 0) {
      queryParams.append('tags', selectedTags.join(','));
    }

    const deletedSelectedBrands = selectedBrands.filter((brandId) => brandId !== deleteBrandId);
    if (deletedSelectedBrands.length > 0) {
      queryParams.append('brands', deletedSelectedBrands.join(','));
    }

    if (selectedTags.length < 1 && deletedSelectedBrands.length < 1 && !query) {
      return basePath;
    }

    return `${basePath}?${queryParams.toString()}`;
  }

  return (
    <>
      <div className={'flex flex-wrap gap-2'}>
        {query && ( // クエリがある場合
          <Link to={deleteQuery()}>
            <Badge
              variant="outline"
              className={'min-h-[28px] rounded-3xl text-[11px]  bg-slate-100 border-slate-100 hover:bg-slate-200 py-1 px-2 text-slate-600 font-normal gap-[0.1ch]'}
            >
              {query}
              <CircleXIcon className="ml-2 h-[17px] w-[17px] text-slate-500" />
            </Badge>
          </Link>
        )}

        {selectedTags.map((tagId) => {
          const tag = tags.find((tag) => tag.id === tagId);
          if (!tag) {
            return null;
          }
          return (
            <Link key={tagId} to={deleteTag(tagId)}>
              <Badge
                variant="outline"
                className={'min-h-[28px] rounded-3xl text-[11px]  bg-slate-100 border-slate-100 hover:bg-slate-200 py-1 px-2 text-slate-600 font-normal gap-[0.1ch]'}
              >
                <HashIcon className="h-[11px] w-[11px]" />
                {tag.tag}
                <CircleXIcon className="ml-2 h-[17px] w-[17px] text-slate-500" />
              </Badge>
            </Link>
          );
        })}


        {selectedBrands.map((brandId) => {
          const brand = brands.find((brand) => brand.id === brandId);
          if (!brand) {
            return null;
          }
          return (
            <Link key={brandId} to={deleteBrand(brandId)}>
              <Badge
                variant="outline"
                className={'min-h-[28px] rounded-3xl text-[11px]  bg-slate-100 border-slate-100 hover:bg-slate-200 py-1 px-2 text-slate-600 font-normal gap-[0.1ch]'}
              >
                {brand.name}
                <CircleXIcon className="ml-2 h-[17px] w-[17px] text-slate-500" />
              </Badge>
            </Link>
          );
        })}

      </div>
    </>
  );
}
